import { supabase } from '@/lib/supabase'
import { useState } from 'react'

interface UsePortalReturn {
  loading: boolean
  error: string | null
  openPortal: () => Promise<void>
}

export function usePortal(): UsePortalReturn {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function openPortal() {
    setLoading(true)
    setError(null)

    const {
      data: { session },
    } = await supabase.auth.getSession()

    const { data, error: fnError } = await supabase.functions.invoke('create-portal-session', {
      body: { returnUrl: window.location.href },
      headers: session?.access_token
        ? { Authorization: `Bearer ${session.access_token}` }
        : undefined,
    })

    if (fnError || !data?.url) {
      setError('Could not open billing portal. Please try again.')
      setLoading(false)
      return
    }

    window.location.href = data.url
  }

  return { loading, error, openPortal }
}
